import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenderNodeDirective } from './directives/render-node.directive';
import {SharedModule} from "@shared/shared.module";
import {SectionWithSubtitleComponent} from "./components/section-with-subtitle.component";
import {DownloadableFileListComponent} from "./components/downloadable-file-list.component";
import {DownloadableFileComponent} from "./components/downloadable-file.component";
import {DownloadableNoticeboardAttachmentComponent} from "./components/downloadable-noticeboard-attachment.component";

@NgModule({
  declarations: [
    RenderNodeDirective,
    SectionWithSubtitleComponent,
    DownloadableFileListComponent,
    DownloadableFileComponent,
    DownloadableNoticeboardAttachmentComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    RenderNodeDirective,
    SectionWithSubtitleComponent,
    DownloadableFileListComponent,
    DownloadableFileComponent,
    DownloadableNoticeboardAttachmentComponent
  ]
})
export class CompositeDetailsModule { }
